import {useTooltipContext} from '../hooks/useTooltipContext'

export const usePieChartTooltipContext = () => {
  return useTooltipContext<{key?: string}>()
}
